import { createSlice } from '@reduxjs/toolkit';

import { IFormsState } from '../../../core/interfaces/IFormsState';
import { FormsReducer } from '../../reducers/FormsReducer';

const initialState: IFormsState = {
    pre_ipaf: null,
    field_changes: null,
};

export const formsSlice = createSlice({
    name: 'forms',
    initialState,
    reducers: FormsReducer,
});

export const { setPreIpafForm, setFieldChange, restoreDataForms } = formsSlice.actions;

export default formsSlice.reducer; 
